export const Characters = {
    RIGHTWARDS_ARROW: '\u2192',
    MIDDLE_DOT: '\u00B7',
    EN_SPACE: '\u2002',
    EN_DASH: '\u2013',
    HYPHEN_MINUS: '\u002D',
    BULLET: '\u2022',
    BLACK_FOUR_POINTED_STAR: '\u2726',
    NO_BREAK_SPACE: '\u00A0',
    SOLIDUS: '\u002F',
    LEFT_DOUBLE_QUOTATION_MARK: '\u201C',
    RIGHT_DOUBLE_QUOTATION_MARK: '\u201D',
    ZERO_WIDTH_SPACE: '\u200B',
    MINUS: '\u2212',
    DOLLAR: '\u0024',
    HORIZONTAL_ELLIPSIS: '\u2026',
    PERCENT_SIGN: '\u0025',
};
